import { Link } from 'react-router';
import { getAllDisciplines } from '../../lib/disciplines.js';
import { useDocumentTitle } from '../../lib/useDocumentTitle.js';

export default function DisciplinesIndex() {
  useDocumentTitle('Disciplines');
  const disciplines = getAllDisciplines();

  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <h1>Disciplines</h1>
      <p className="meta">The six core verticals YACC organizes around.</p>

      <ul className="hairline-list">
        {disciplines.map((d, i) => (
          <li key={d.slug}>
            <p className="meta">{String(i + 1).padStart(2, '0')}</p>
            <h2>
              <Link to={`/disciplines/${d.slug}`}>{d.name}</Link>
            </h2>
            <p>{d.tagline}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
